import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'root',
    templateUrl: './app.component.html'
})
export class AppComponent implements OnInit {
    constructor() {}

    ngOnInit(): void {}
}
